function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "document-lock_svg__a",
  d: "M32.63 7.89v33.16l-1.71 1.71H1.74l-1.71-1.7V2L1.74.29h23.27l7.62 7.6z"
}), /*#__PURE__*/React.createElement("path", {
  id: "document-lock_svg__c",
  d: "M21.37.41V19.8l-1.71 1.71H.24z"
}), /*#__PURE__*/React.createElement("path", {
  id: "document-lock_svg__e",
  d: "M8.03 7.89H.41V.29z"
}), /*#__PURE__*/React.createElement("path", {
  id: "document-lock_svg__g",
  d: "M8.56.26c4.15 0 8.3 2.64 8.3 7.92v16.93H.26V8.18C.27 2.9 4.42.26 8.57.26zm0 2.72c-1.53 0-2.99.49-4 1.35a4.8 4.8 0 00-1.63 3.85V22.4H14.2V8.2a4.8 4.8 0 00-1.64-3.86 6.24 6.24 0 00-4-1.35z"
}), /*#__PURE__*/React.createElement("path", {
  id: "document-lock_svg__i",
  d: "M20.5 15.89H2.8L.08 13.13V2.82L2.79.06h17.7l2.71 2.76v10.31l-2.7 2.76z"
}), /*#__PURE__*/React.createElement("path", {
  id: "document-lock_svg__k",
  d: "M17.17 2.5v10.95l-2.4 2.43H.06L14.6.07h.16l2.4 2.44z"
}), /*#__PURE__*/React.createElement("path", {
  id: "document-lock_svg__m",
  d: "M3.34 3.82L5.2 7.6H.26l1.87-3.8A1.92 1.92 0 01.86 2C.86.93 1.7.07 2.74.07s1.89.86 1.89 1.92c0 .85-.54 1.58-1.3 1.83z"
}));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(.34 -.28)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "document-lock_svg__b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#document-lock_svg__a"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#FFCE32",
  d: "M-2.06-1.8h36.77v46.65H-2.06z",
  mask: "url(#document-lock_svg__b)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(11.6 20.98)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "document-lock_svg__d",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#document-lock_svg__c"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#D8B87A",
  d: "M-1.85-1.67h25.3v25.26h-25.3z",
  mask: "url(#document-lock_svg__d)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(24.95 -.28)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "document-lock_svg__f",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#document-lock_svg__e"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#F8FBCF",
  d: "M-1.67-1.8h11.79V9.97h-11.8z",
  mask: "url(#document-lock_svg__f)"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#003035",
  fillRule: "nonzero",
  d: "M27.18 13.21v2.5H7.82v-2.5zm0 3.96v2.5H7.82v-2.5zm0 3.96v2.5H7.82v-2.5zm0 3.97v2.5H7.82v-2.5zm0 3.96v2.5H7.82v-2.5z"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(27.03 22.32)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "document-lock_svg__h",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#document-lock_svg__g"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#003035",
  d: "M-1.14-1.17h19.4v27.7h-19.4z",
  mask: "url(#document-lock_svg__h)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(23.95 31.63)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "document-lock_svg__j",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#document-lock_svg__i"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#23E5DB",
  d: "M-1.31-1.37H24.6v18.69H-1.3z",
  mask: "url(#document-lock_svg__j)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(29.98 31.63)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "document-lock_svg__l",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#document-lock_svg__k"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#00A49F",
  d: "M-1.35-1.37h19.92v18.69H-1.35z",
  mask: "url(#document-lock_svg__l)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(32.92 35.77)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "document-lock_svg__n",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#document-lock_svg__m"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#003035",
  d: "M-1.15-1.36h7.76V9.03h-7.76z",
  mask: "url(#document-lock_svg__n)"
})));

const SvgDocumentLock = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 48 48"
}, props), _ref, _ref2);

export default SvgDocumentLock;